/**
 * The `launcher_dispatch_log.error` prefixes for the two terminal row states
 * the background build (`playbooks.dispatch-fanout`, plan 2026-10-14-002 U0b)
 * adds next to `copy_defect:` / `sender_missing:`.
 *
 * A dependency-free leaf on purpose: the server writes these
 * (`send.ts`'s builder, `dispatch-fanout.ts`) and the Dispatch log classifier
 * reads them (`dispatch-inspector-logic.ts`, bundled into the browser), so
 * neither side may drag the other's module graph in.
 */

/**
 * The member was in the approved, frozen roster but is no longer a member of
 * the campaign when the background build reached them (a Salesforce resync
 * removed them). Nothing is sent; never retryable — there is nobody to send to.
 */
export const MEMBER_REMOVED_ERROR_PREFIX = 'member_removed:';

/** The rep-facing half of a `member_removed:` row. */
export const MEMBER_REMOVED_DETAIL =
  'This person was removed from the campaign after the send was approved, so nothing was sent to them.';

/**
 * Terra could not build this member's message at all (a build that kept
 * failing, or a structural problem found only at build time). Nothing was
 * sent and there is no stored job a Retry could re-send.
 */
export const BUILD_FAILED_ERROR_PREFIX = 'build_failed:';
